module.exports = __webpack_public_path__ + "img/work-clothes.6f77664a.webp";